import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";
import { SERVICES } from "@/lib/site-data";

const ease = [0.22, 1, 0.36, 1];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="relative py-28 md:py-36">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <SectionHeading
          eyebrow="Nos services"
          title="Toute la couverture, du faîtage à la gouttière"
          copy="Six savoir-faire, une seule exigence : une toiture étanche, belle et durable."
        />
        <div className="mt-16 grid grid-cols-2 gap-3 sm:gap-5 lg:grid-cols-3 lg:pb-8">
          {SERVICES.map((s, i) => (
            <motion.a
              key={s.id}
              href="#devis"
              data-testid={`service-card-${s.id}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: (i % 3) * 0.1, duration: 0.7, ease }}
              className={`group relative flex flex-col border border-white/5 bg-[#14171D] p-4 transition-colors duration-300 hover:border-terra/40 hover:bg-[#181C24] sm:p-8 ${
                i % 3 === 1 ? "lg:translate-y-8" : ""
              }`}
            >
              <div className="flex items-start justify-between">
                <span className="flex h-9 w-9 items-center justify-center border border-terra/30 bg-terra/10 text-terra transition-colors duration-300 group-hover:bg-terra group-hover:text-white sm:h-12 sm:w-12">
                  <s.icon className="h-4 w-4 sm:h-5 sm:w-5" />
                </span>
                <span className="hidden font-mono text-xs text-slate-600 sm:block">{String(i + 1).padStart(2, "0")}</span>
              </div>
              <h3 className="mt-4 font-serif text-sm leading-snug text-slate-100 sm:mt-7 sm:text-xl">{s.title}</h3>
              <p className="mt-2 line-clamp-3 text-[11px] leading-relaxed text-slate-400 sm:mt-3 sm:line-clamp-none sm:text-sm">{s.desc}</p>
              <ul className="mt-6 hidden space-y-2 border-t border-white/5 pt-5 sm:block">
                {s.points.map((p) => (
                  <li key={p} className="flex items-center gap-2.5 text-xs text-slate-400">
                    <span className="h-1 w-1 rotate-45 bg-terra" />
                    {p}
                  </li>
                ))}
              </ul>
              <span className="mt-6 hidden items-center gap-2 text-xs font-semibold uppercase tracking-widest text-terra opacity-0 transition-opacity duration-300 group-hover:opacity-100 sm:inline-flex">
                Demander ce service
                <ArrowUpRight className="h-3.5 w-3.5" />
              </span>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
